import React from 'react';
import { useSelect } from '@wordpress/data';
import { store as coreStore } from '@wordpress/core-data';
import { useState } from '@wordpress/element';
import ServerSideRender from '@wordpress/server-side-render';
import { registerBlockType } from '@wordpress/blocks';
import { InspectorControls, useBlockProps, AlignmentToolbar, BlockControls } from '@wordpress/block-editor';
import { Button, PanelBody, SelectControl, Placeholder, TextControl } from '@wordpress/components';

registerBlockType('propstack/propstack-data-inserter', {
    // Block configuration...
    title: 'Propstack Data Inserter',
    description: 'A block for inserting data from the Propstack API.',
    icon: 'analytics', // Use any WordPress Dashicon or a custom SVG
    category: 'theme', // Use any existing category or a custom one
    supports: { inspector: true, multiple: true, className: true },
    attributes: {
        selectedField: {
            type: 'string',
            default: '',
        },
        postId: {
            type: 'number',
            default: '',
        },
        textAlign: {
            type: 'string',
            default: 'left' // Set default alignment
        },
        customFieldValue: {
            type: 'string',
            default: '',
        },
        prefix: {
            type: 'string',
            default: '',
        },
        suffix: {
            type: 'string',
            default: '',
        }
    },

    usesContext: ["postId", "postType", "queryId"],


    edit: function (props) {

        const { attributes, setAttributes, context } = props;
        const { selectedField, textAlign, customFieldValue } = attributes;


        const [localCustomFieldValue, setLocalCustomFieldValue] = useState(customFieldValue || '');


        const onChangeCustomFieldValue = (value) => {
            setAttributes({ customFieldValue: value });
            setLocalCustomFieldValue(value);
        };

        const isCustomField = selectedField && selectedField.includes("custom_fields");

        console.log("Selected Field:", selectedField);
        console.log("Is Custom Field:", isCustomField);


        const clearSelection = () => {
            setAttributes({ selectedField: '' }); // Resetting the selectedField attribute
        };

        // Function to update text alignment
        const onChangeAlignment = (newAlignment) => {
            setAttributes({ textAlign: newAlignment });
        };

        const postId = context.postId; // Access postId from context

        // Helper function to transform class properties into select options with optgroups
        const selectOptions = [
            // The first default option acting as a placeholder
            <option value="">{'Select field'}</option>,
            ...Object.keys(propstackFieldsData.classProperties).map((className) => (
                <optgroup label={className.replace(/\\/g, ' - ')}>
                    {propstackFieldsData.classProperties[className].map(property => (
                        <option value={`${className}.${property}`}>{property}</option>
                    ))}
                </optgroup>
            ))
        ];

        return (
            <div {...useBlockProps()}>
                <BlockControls>
                    <AlignmentToolbar
                        value={textAlign}
                        onChange={onChangeAlignment}
                    />
                </BlockControls>
                <InspectorControls>
                    <PanelBody title="Field Settings" initialOpen={true}>
                        <SelectControl
                            label="Select Field"
                            value={selectedField}
                            onChange={(newField) => setAttributes({ selectedField: newField })}
                            children={selectOptions}
                        />
                        {isCustomField && (
                            <TextControl
                                label="Custom Field Value"
                                value={localCustomFieldValue}
                                onChange={onChangeCustomFieldValue}
                            />
                        )}
                        <Button
                            isSecondary
                            onClick={clearSelection}
                            className="components-select-control__clear"
                        >
                            Clear
                        </Button>
                        <TextControl
                            label="Prefix"
                            value={attributes.prefix}
                            onChange={(value) => setAttributes({ prefix: value })}
                        />
                        <TextControl
                            label="Suffix"
                            value={attributes.suffix}
                            onChange={(value) => setAttributes({ suffix: value })}
                        />
                    </PanelBody>
                </InspectorControls>
                {selectedField ? (
                    <ServerSideRender
                        block="propstack/propstack-data-inserter"
                        attributes={{
                            selectedField: selectedField,
                            postId: postId,
                            textAlign: attributes.textAlign, // Make sure to pass this attribute to the server,
                            customFieldValue: customFieldValue,
                            prefix: attributes.prefix,
                            suffix: attributes.suffix
                        }}
                    />
                ) : (
                    <Placeholder
                        instructions="Select a field from the settings to display its data."
                    >
                        <div>No field selected. Please select a field.</div>
                    </Placeholder>
                )}
            </div>
        );
    },




    save: function () {
        // Server-side rendering only
        return null;
    },
});
